/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as FarmerValidationImport } from './routes/farmer-validation'
import { Route as FarmerConsentImport } from './routes/farmer-consent'
import { Route as AuthImport } from './routes/_auth'
import { Route as AppImport } from './routes/_app'
import { Route as IndexImport } from './routes/index'
import { Route as AuthResetPasswordImport } from './routes/_auth/reset-password'
import { Route as AuthLoginImport } from './routes/_auth/login'
import { Route as AppSupportImport } from './routes/_app/support'
import { Route as AppImportImport } from './routes/_app/import'
import { Route as AppDashboardImport } from './routes/_app/dashboard'
import { Route as AppAdminImport } from './routes/_app/_admin'
import { Route as AppOsValidationFormsImport } from './routes/_app/os/validation-forms'
import { Route as AppOsSurfacesMapImport } from './routes/_app/os/surfaces-map'
import { Route as AppOsSurfacesAllocationImport } from './routes/_app/os/surfaces-allocation'
import { Route as AppOsNgpSamplingAssignmentImport } from './routes/_app/os/ngp-sampling-assignment'
import { Route as AppOsLotsImport } from './routes/_app/os/lots'
import { Route as AppOsLotReviewsImport } from './routes/_app/os/lot-reviews'
import { Route as AppOsImportImport } from './routes/_app/os/import'
import { Route as AppOsDashboardImport } from './routes/_app/os/dashboard'
import { Route as AppOsContractsImport } from './routes/_app/os/contracts'
import { Route as AppAdminSamplingPlansMapImport } from './routes/_app/_admin/sampling-plans-map'
import { Route as AppAdminSamplingPlansImport } from './routes/_app/_admin/sampling-plans'
import { Route as AppAdminResultsImport } from './routes/_app/_admin/results'
import { Route as AppAdminPratiquesImport } from './routes/_app/_admin/pratiques'
import { Route as AppAdminOrganisationsImport } from './routes/_app/_admin/organisations'
import { Route as AppAdminOrdersImport } from './routes/_app/_admin/orders'
import { Route as AppAdminNgpSamplingAssignmentImport } from './routes/_app/_admin/ngp-sampling-assignment'
import { Route as AppAdminGpSamplingAssignmentImport } from './routes/_app/_admin/gp-sampling-assignment'
import { Route as AppOsValidationFormsValidationFormIdImport } from './routes/_app/os/validation-forms_.$validationFormId'
import { Route as AppOsLotReviewsLotIdImport } from './routes/_app/os/lot-reviews_.$lotId'
import { Route as AppOsContractsContractIdImport } from './routes/_app/os/contracts_.$contractId'
import { Route as AppAdminSamplingPlansIdImport } from './routes/_app/_admin/sampling-plans_.$id'
import { Route as AppAdminResultsIdImport } from './routes/_app/_admin/results_/$id'
import { Route as AppAdminOrdersIdImport } from './routes/_app/_admin/orders_/$id'
import { Route as AppOsContractsContractIdIndexImport } from './routes/_app/os/contracts_.$contractId.index'
import { Route as AppAdminResultsIdIndexImport } from './routes/_app/_admin/results_/$id.index'
import { Route as AppOsContractsContractIdParcellesImport } from './routes/_app/os/contracts_.$contractId.parcelles'
import { Route as AppOsContractsContractIdBatchesImport } from './routes/_app/os/contracts_.$contractId.batches'
import { Route as AppAdminResultsIdTableImport } from './routes/_app/_admin/results_/$id.table'
import { Route as AppAdminResultsIdMapImport } from './routes/_app/_admin/results_/$id.map'
import { Route as AppAdminOrdersIdTrackImport } from './routes/_app/_admin/orders_/$id.track'
import { Route as AppAdminOrdersIdPointsImport } from './routes/_app/_admin/orders_/$id.points'
import { Route as AppAdminOrdersIdMapImport } from './routes/_app/_admin/orders_/$id.map'
import { Route as AppOsContractsContractIdBatchesBatchIdImport } from './routes/_app/os/contracts_.$contractId.batches_.$batchId'

// Create Virtual Routes

const AuthLostPasswordLazyImport = createFileRoute('/_auth/lost-password')()
const AppProfileLazyImport = createFileRoute('/_app/profile')()
const AppAdminUsersLazyImport = createFileRoute('/_app/_admin/users')()
const AppAdminAccountsLazyImport = createFileRoute('/_app/_admin/accounts')()
const AppAdminUsersCreateLazyImport = createFileRoute(
  '/_app/_admin/users_/create',
)()
const AppAdminOrganisationsCreateLazyImport = createFileRoute(
  '/_app/_admin/organisations_/create',
)()
const AppAdminAccountsCreateLazyImport = createFileRoute(
  '/_app/_admin/accounts_/create',
)()
const AppAdminUsersUserIdEditLazyImport = createFileRoute(
  '/_app/_admin/users_/$userId/edit',
)()
const AppAdminOrganisationsOrganisationIdEditLazyImport = createFileRoute(
  '/_app/_admin/organisations_/$organisationId/edit',
)()
const AppAdminAccountsAccountIdEditLazyImport = createFileRoute(
  '/_app/_admin/accounts_/$accountId/edit',
)()

// Create/Update Routes

const FarmerValidationRoute = FarmerValidationImport.update({
  id: '/farmer-validation',
  path: '/farmer-validation',
  getParentRoute: () => rootRoute,
} as any)

const FarmerConsentRoute = FarmerConsentImport.update({
  id: '/farmer-consent',
  path: '/farmer-consent',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthLostPasswordLazyRoute = AuthLostPasswordLazyImport.update({
  id: '/lost-password',
  path: '/lost-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/lost-password.lazy').then((d) => d.Route),
)

const AppProfileLazyRoute = AppProfileLazyImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any).lazy(() => import('./routes/_app/profile.lazy').then((d) => d.Route))

const AuthResetPasswordRoute = AuthResetPasswordImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)

const AuthLoginRoute = AuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)

const AppSupportRoute = AppSupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)

const AppImportRoute = AppImportImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => AppRoute,
} as any)

const AppDashboardRoute = AppDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminRoute = AppAdminImport.update({
  id: '/_admin',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminUsersLazyRoute = AppAdminUsersLazyImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/users.lazy').then((d) => d.Route),
)

const AppAdminAccountsLazyRoute = AppAdminAccountsLazyImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/accounts.lazy').then((d) => d.Route),
)

const AppOsValidationFormsRoute = AppOsValidationFormsImport.update({
  id: '/os/validation-forms',
  path: '/os/validation-forms',
  getParentRoute: () => AppRoute,
} as any)

const AppOsSurfacesMapRoute = AppOsSurfacesMapImport.update({
  id: '/os/surfaces-map',
  path: '/os/surfaces-map',
  getParentRoute: () => AppRoute,
} as any)

const AppOsSurfacesAllocationRoute = AppOsSurfacesAllocationImport.update({
  id: '/os/surfaces-allocation',
  path: '/os/surfaces-allocation',
  getParentRoute: () => AppRoute,
} as any)

const AppOsNgpSamplingAssignmentRoute = AppOsNgpSamplingAssignmentImport.update(
  {
    id: '/os/ngp-sampling-assignment',
    path: '/os/ngp-sampling-assignment',
    getParentRoute: () => AppRoute,
  } as any,
)

const AppOsLotsRoute = AppOsLotsImport.update({
  id: '/os/lots',
  path: '/os/lots',
  getParentRoute: () => AppRoute,
} as any)

const AppOsLotReviewsRoute = AppOsLotReviewsImport.update({
  id: '/os/lot-reviews',
  path: '/os/lot-reviews',
  getParentRoute: () => AppRoute,
} as any)

const AppOsImportRoute = AppOsImportImport.update({
  id: '/os/import',
  path: '/os/import',
  getParentRoute: () => AppRoute,
} as any)

const AppOsDashboardRoute = AppOsDashboardImport.update({
  id: '/os/dashboard',
  path: '/os/dashboard',
  getParentRoute: () => AppRoute,
} as any)

const AppOsContractsRoute = AppOsContractsImport.update({
  id: '/os/contracts',
  path: '/os/contracts',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminSamplingPlansMapRoute = AppAdminSamplingPlansMapImport.update({
  id: '/sampling-plans-map',
  path: '/sampling-plans-map',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminSamplingPlansRoute = AppAdminSamplingPlansImport.update({
  id: '/sampling-plans',
  path: '/sampling-plans',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminResultsRoute = AppAdminResultsImport.update({
  id: '/results',
  path: '/results',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminPratiquesRoute = AppAdminPratiquesImport.update({
  id: '/pratiques',
  path: '/pratiques',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminOrganisationsRoute = AppAdminOrganisationsImport.update({
  id: '/organisations',
  path: '/organisations',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminOrdersRoute = AppAdminOrdersImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminNgpSamplingAssignmentRoute =
  AppAdminNgpSamplingAssignmentImport.update({
    id: '/ngp-sampling-assignment',
    path: '/ngp-sampling-assignment',
    getParentRoute: () => AppAdminRoute,
  } as any)

const AppAdminGpSamplingAssignmentRoute =
  AppAdminGpSamplingAssignmentImport.update({
    id: '/gp-sampling-assignment',
    path: '/gp-sampling-assignment',
    getParentRoute: () => AppAdminRoute,
  } as any)

const AppAdminUsersCreateLazyRoute = AppAdminUsersCreateLazyImport.update({
  id: '/users_/create',
  path: '/users/create',
  getParentRoute: () => AppAdminRoute,
} as any).lazy(() =>
  import('./routes/_app/_admin/users_/create.lazy').then((d) => d.Route),
)

const AppAdminOrganisationsCreateLazyRoute =
  AppAdminOrganisationsCreateLazyImport.update({
    id: '/organisations_/create',
    path: '/organisations/create',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/organisations_/create.lazy').then(
      (d) => d.Route,
    ),
  )

const AppAdminAccountsCreateLazyRoute = AppAdminAccountsCreateLazyImport.update(
  {
    id: '/accounts_/create',
    path: '/accounts/create',
    getParentRoute: () => AppAdminRoute,
  } as any,
).lazy(() =>
  import('./routes/_app/_admin/accounts_/create.lazy').then((d) => d.Route),
)

const AppOsValidationFormsValidationFormIdRoute =
  AppOsValidationFormsValidationFormIdImport.update({
    id: '/os/validation-forms_/$validationFormId',
    path: '/os/validation-forms/$validationFormId',
    getParentRoute: () => AppRoute,
  } as any)

const AppOsLotReviewsLotIdRoute = AppOsLotReviewsLotIdImport.update({
  id: '/os/lot-reviews_/$lotId',
  path: '/os/lot-reviews/$lotId',
  getParentRoute: () => AppRoute,
} as any)

const AppOsContractsContractIdRoute = AppOsContractsContractIdImport.update({
  id: '/os/contracts_/$contractId',
  path: '/os/contracts/$contractId',
  getParentRoute: () => AppRoute,
} as any)

const AppAdminSamplingPlansIdRoute = AppAdminSamplingPlansIdImport.update({
  id: '/sampling-plans_/$id',
  path: '/sampling-plans/$id',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminResultsIdRoute = AppAdminResultsIdImport.update({
  id: '/results_/$id',
  path: '/results/$id',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppAdminOrdersIdRoute = AppAdminOrdersIdImport.update({
  id: '/orders_/$id',
  path: '/orders/$id',
  getParentRoute: () => AppAdminRoute,
} as any)

const AppOsContractsContractIdIndexRoute =
  AppOsContractsContractIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppOsContractsContractIdRoute,
  } as any)

const AppAdminResultsIdIndexRoute = AppAdminResultsIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminResultsIdRoute,
} as any)

const AppAdminUsersUserIdEditLazyRoute =
  AppAdminUsersUserIdEditLazyImport.update({
    id: '/users_/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/users_/$userId.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AppAdminOrganisationsOrganisationIdEditLazyRoute =
  AppAdminOrganisationsOrganisationIdEditLazyImport.update({
    id: '/organisations_/$organisationId/edit',
    path: '/organisations/$organisationId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import(
      './routes/_app/_admin/organisations_/$organisationId.edit.lazy'
    ).then((d) => d.Route),
  )

const AppAdminAccountsAccountIdEditLazyRoute =
  AppAdminAccountsAccountIdEditLazyImport.update({
    id: '/accounts_/$accountId/edit',
    path: '/accounts/$accountId/edit',
    getParentRoute: () => AppAdminRoute,
  } as any).lazy(() =>
    import('./routes/_app/_admin/accounts_/$accountId.edit.lazy').then(
      (d) => d.Route,
    ),
  )

const AppOsContractsContractIdParcellesRoute =
  AppOsContractsContractIdParcellesImport.update({
    id: '/parcelles',
    path: '/parcelles',
    getParentRoute: () => AppOsContractsContractIdRoute,
  } as any)

const AppOsContractsContractIdBatchesRoute =
  AppOsContractsContractIdBatchesImport.update({
    id: '/batches',
    path: '/batches',
    getParentRoute: () => AppOsContractsContractIdRoute,
  } as any)

const AppAdminResultsIdTableRoute = AppAdminResultsIdTableImport.update({
  id: '/table',
  path: '/table',
  getParentRoute: () => AppAdminResultsIdRoute,
} as any)

const AppAdminResultsIdMapRoute = AppAdminResultsIdMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppAdminResultsIdRoute,
} as any)

const AppAdminOrdersIdTrackRoute = AppAdminOrdersIdTrackImport.update({
  id: '/track',
  path: '/track',
  getParentRoute: () => AppAdminOrdersIdRoute,
} as any)

const AppAdminOrdersIdPointsRoute = AppAdminOrdersIdPointsImport.update({
  id: '/points',
  path: '/points',
  getParentRoute: () => AppAdminOrdersIdRoute,
} as any)

const AppAdminOrdersIdMapRoute = AppAdminOrdersIdMapImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AppAdminOrdersIdRoute,
} as any)

const AppOsContractsContractIdBatchesBatchIdRoute =
  AppOsContractsContractIdBatchesBatchIdImport.update({
    id: '/batches_/$batchId',
    path: '/batches/$batchId',
    getParentRoute: () => AppOsContractsContractIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/farmer-consent': {
      id: '/farmer-consent'
      path: '/farmer-consent'
      fullPath: '/farmer-consent'
      preLoaderRoute: typeof FarmerConsentImport
      parentRoute: typeof rootRoute
    }
    '/farmer-validation': {
      id: '/farmer-validation'
      path: '/farmer-validation'
      fullPath: '/farmer-validation'
      preLoaderRoute: typeof FarmerValidationImport
      parentRoute: typeof rootRoute
    }
    '/_app/_admin': {
      id: '/_app/_admin'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppAdminImport
      parentRoute: typeof AppImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/import': {
      id: '/_app/import'
      path: '/import'
      fullPath: '/import'
      preLoaderRoute: typeof AppImportImport
      parentRoute: typeof AppImport
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportImport
      parentRoute: typeof AppImport
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginImport
      parentRoute: typeof AuthImport
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordImport
      parentRoute: typeof AuthImport
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileLazyImport
      parentRoute: typeof AppImport
    }
    '/_auth/lost-password': {
      id: '/_auth/lost-password'
      path: '/lost-password'
      fullPath: '/lost-password'
      preLoaderRoute: typeof AuthLostPasswordLazyImport
      parentRoute: typeof AuthImport
    }
    '/_app/_admin/gp-sampling-assignment': {
      id: '/_app/_admin/gp-sampling-assignment'
      path: '/gp-sampling-assignment'
      fullPath: '/gp-sampling-assignment'
      preLoaderRoute: typeof AppAdminGpSamplingAssignmentImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/ngp-sampling-assignment': {
      id: '/_app/_admin/ngp-sampling-assignment'
      path: '/ngp-sampling-assignment'
      fullPath: '/ngp-sampling-assignment'
      preLoaderRoute: typeof AppAdminNgpSamplingAssignmentImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/orders': {
      id: '/_app/_admin/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppAdminOrdersImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/organisations': {
      id: '/_app/_admin/organisations'
      path: '/organisations'
      fullPath: '/organisations'
      preLoaderRoute: typeof AppAdminOrganisationsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/pratiques': {
      id: '/_app/_admin/pratiques'
      path: '/pratiques'
      fullPath: '/pratiques'
      preLoaderRoute: typeof AppAdminPratiquesImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/results': {
      id: '/_app/_admin/results'
      path: '/results'
      fullPath: '/results'
      preLoaderRoute: typeof AppAdminResultsImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/sampling-plans': {
      id: '/_app/_admin/sampling-plans'
      path: '/sampling-plans'
      fullPath: '/sampling-plans'
      preLoaderRoute: typeof AppAdminSamplingPlansImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/sampling-plans-map': {
      id: '/_app/_admin/sampling-plans-map'
      path: '/sampling-plans-map'
      fullPath: '/sampling-plans-map'
      preLoaderRoute: typeof AppAdminSamplingPlansMapImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/os/contracts': {
      id: '/_app/os/contracts'
      path: '/os/contracts'
      fullPath: '/os/contracts'
      preLoaderRoute: typeof AppOsContractsImport
      parentRoute: typeof AppImport
    }
    '/_app/os/dashboard': {
      id: '/_app/os/dashboard'
      path: '/os/dashboard'
      fullPath: '/os/dashboard'
      preLoaderRoute: typeof AppOsDashboardImport
      parentRoute: typeof AppImport
    }
    '/_app/os/import': {
      id: '/_app/os/import'
      path: '/os/import'
      fullPath: '/os/import'
      preLoaderRoute: typeof AppOsImportImport
      parentRoute: typeof AppImport
    }
    '/_app/os/lot-reviews': {
      id: '/_app/os/lot-reviews'
      path: '/os/lot-reviews'
      fullPath: '/os/lot-reviews'
      preLoaderRoute: typeof AppOsLotReviewsImport
      parentRoute: typeof AppImport
    }
    '/_app/os/lots': {
      id: '/_app/os/lots'
      path: '/os/lots'
      fullPath: '/os/lots'
      preLoaderRoute: typeof AppOsLotsImport
      parentRoute: typeof AppImport
    }
    '/_app/os/ngp-sampling-assignment': {
      id: '/_app/os/ngp-sampling-assignment'
      path: '/os/ngp-sampling-assignment'
      fullPath: '/os/ngp-sampling-assignment'
      preLoaderRoute: typeof AppOsNgpSamplingAssignmentImport
      parentRoute: typeof AppImport
    }
    '/_app/os/surfaces-allocation': {
      id: '/_app/os/surfaces-allocation'
      path: '/os/surfaces-allocation'
      fullPath: '/os/surfaces-allocation'
      preLoaderRoute: typeof AppOsSurfacesAllocationImport
      parentRoute: typeof AppImport
    }
    '/_app/os/surfaces-map': {
      id: '/_app/os/surfaces-map'
      path: '/os/surfaces-map'
      fullPath: '/os/surfaces-map'
      preLoaderRoute: typeof AppOsSurfacesMapImport
      parentRoute: typeof AppImport
    }
    '/_app/os/validation-forms': {
      id: '/_app/os/validation-forms'
      path: '/os/validation-forms'
      fullPath: '/os/validation-forms'
      preLoaderRoute: typeof AppOsValidationFormsImport
      parentRoute: typeof AppImport
    }
    '/_app/_admin/accounts': {
      id: '/_app/_admin/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAdminAccountsLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users': {
      id: '/_app/_admin/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppAdminUsersLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/orders_/$id': {
      id: '/_app/_admin/orders_/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof AppAdminOrdersIdImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/results_/$id': {
      id: '/_app/_admin/results_/$id'
      path: '/results/$id'
      fullPath: '/results/$id'
      preLoaderRoute: typeof AppAdminResultsIdImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/sampling-plans_/$id': {
      id: '/_app/_admin/sampling-plans_/$id'
      path: '/sampling-plans/$id'
      fullPath: '/sampling-plans/$id'
      preLoaderRoute: typeof AppAdminSamplingPlansIdImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/os/contracts_/$contractId': {
      id: '/_app/os/contracts_/$contractId'
      path: '/os/contracts/$contractId'
      fullPath: '/os/contracts/$contractId'
      preLoaderRoute: typeof AppOsContractsContractIdImport
      parentRoute: typeof AppImport
    }
    '/_app/os/lot-reviews_/$lotId': {
      id: '/_app/os/lot-reviews_/$lotId'
      path: '/os/lot-reviews/$lotId'
      fullPath: '/os/lot-reviews/$lotId'
      preLoaderRoute: typeof AppOsLotReviewsLotIdImport
      parentRoute: typeof AppImport
    }
    '/_app/os/validation-forms_/$validationFormId': {
      id: '/_app/os/validation-forms_/$validationFormId'
      path: '/os/validation-forms/$validationFormId'
      fullPath: '/os/validation-forms/$validationFormId'
      preLoaderRoute: typeof AppOsValidationFormsValidationFormIdImport
      parentRoute: typeof AppImport
    }
    '/_app/_admin/accounts_/create': {
      id: '/_app/_admin/accounts_/create'
      path: '/accounts/create'
      fullPath: '/accounts/create'
      preLoaderRoute: typeof AppAdminAccountsCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/organisations_/create': {
      id: '/_app/_admin/organisations_/create'
      path: '/organisations/create'
      fullPath: '/organisations/create'
      preLoaderRoute: typeof AppAdminOrganisationsCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users_/create': {
      id: '/_app/_admin/users_/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof AppAdminUsersCreateLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/orders_/$id/map': {
      id: '/_app/_admin/orders_/$id/map'
      path: '/map'
      fullPath: '/orders/$id/map'
      preLoaderRoute: typeof AppAdminOrdersIdMapImport
      parentRoute: typeof AppAdminOrdersIdImport
    }
    '/_app/_admin/orders_/$id/points': {
      id: '/_app/_admin/orders_/$id/points'
      path: '/points'
      fullPath: '/orders/$id/points'
      preLoaderRoute: typeof AppAdminOrdersIdPointsImport
      parentRoute: typeof AppAdminOrdersIdImport
    }
    '/_app/_admin/orders_/$id/track': {
      id: '/_app/_admin/orders_/$id/track'
      path: '/track'
      fullPath: '/orders/$id/track'
      preLoaderRoute: typeof AppAdminOrdersIdTrackImport
      parentRoute: typeof AppAdminOrdersIdImport
    }
    '/_app/_admin/results_/$id/map': {
      id: '/_app/_admin/results_/$id/map'
      path: '/map'
      fullPath: '/results/$id/map'
      preLoaderRoute: typeof AppAdminResultsIdMapImport
      parentRoute: typeof AppAdminResultsIdImport
    }
    '/_app/_admin/results_/$id/table': {
      id: '/_app/_admin/results_/$id/table'
      path: '/table'
      fullPath: '/results/$id/table'
      preLoaderRoute: typeof AppAdminResultsIdTableImport
      parentRoute: typeof AppAdminResultsIdImport
    }
    '/_app/os/contracts_/$contractId/batches': {
      id: '/_app/os/contracts_/$contractId/batches'
      path: '/batches'
      fullPath: '/os/contracts/$contractId/batches'
      preLoaderRoute: typeof AppOsContractsContractIdBatchesImport
      parentRoute: typeof AppOsContractsContractIdImport
    }
    '/_app/os/contracts_/$contractId/parcelles': {
      id: '/_app/os/contracts_/$contractId/parcelles'
      path: '/parcelles'
      fullPath: '/os/contracts/$contractId/parcelles'
      preLoaderRoute: typeof AppOsContractsContractIdParcellesImport
      parentRoute: typeof AppOsContractsContractIdImport
    }
    '/_app/_admin/accounts_/$accountId/edit': {
      id: '/_app/_admin/accounts_/$accountId/edit'
      path: '/accounts/$accountId/edit'
      fullPath: '/accounts/$accountId/edit'
      preLoaderRoute: typeof AppAdminAccountsAccountIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/organisations_/$organisationId/edit': {
      id: '/_app/_admin/organisations_/$organisationId/edit'
      path: '/organisations/$organisationId/edit'
      fullPath: '/organisations/$organisationId/edit'
      preLoaderRoute: typeof AppAdminOrganisationsOrganisationIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/users_/$userId/edit': {
      id: '/_app/_admin/users_/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof AppAdminUsersUserIdEditLazyImport
      parentRoute: typeof AppAdminImport
    }
    '/_app/_admin/results_/$id/': {
      id: '/_app/_admin/results_/$id/'
      path: '/'
      fullPath: '/results/$id/'
      preLoaderRoute: typeof AppAdminResultsIdIndexImport
      parentRoute: typeof AppAdminResultsIdImport
    }
    '/_app/os/contracts_/$contractId/': {
      id: '/_app/os/contracts_/$contractId/'
      path: '/'
      fullPath: '/os/contracts/$contractId/'
      preLoaderRoute: typeof AppOsContractsContractIdIndexImport
      parentRoute: typeof AppOsContractsContractIdImport
    }
    '/_app/os/contracts_/$contractId/batches_/$batchId': {
      id: '/_app/os/contracts_/$contractId/batches_/$batchId'
      path: '/batches/$batchId'
      fullPath: '/os/contracts/$contractId/batches/$batchId'
      preLoaderRoute: typeof AppOsContractsContractIdBatchesBatchIdImport
      parentRoute: typeof AppOsContractsContractIdImport
    }
  }
}

// Create and export the route tree

interface AppAdminOrdersIdRouteChildren {
  AppAdminOrdersIdMapRoute: typeof AppAdminOrdersIdMapRoute
  AppAdminOrdersIdPointsRoute: typeof AppAdminOrdersIdPointsRoute
  AppAdminOrdersIdTrackRoute: typeof AppAdminOrdersIdTrackRoute
}

const AppAdminOrdersIdRouteChildren: AppAdminOrdersIdRouteChildren = {
  AppAdminOrdersIdMapRoute: AppAdminOrdersIdMapRoute,
  AppAdminOrdersIdPointsRoute: AppAdminOrdersIdPointsRoute,
  AppAdminOrdersIdTrackRoute: AppAdminOrdersIdTrackRoute,
}

const AppAdminOrdersIdRouteWithChildren =
  AppAdminOrdersIdRoute._addFileChildren(AppAdminOrdersIdRouteChildren)

interface AppAdminResultsIdRouteChildren {
  AppAdminResultsIdMapRoute: typeof AppAdminResultsIdMapRoute
  AppAdminResultsIdTableRoute: typeof AppAdminResultsIdTableRoute
  AppAdminResultsIdIndexRoute: typeof AppAdminResultsIdIndexRoute
}

const AppAdminResultsIdRouteChildren: AppAdminResultsIdRouteChildren = {
  AppAdminResultsIdMapRoute: AppAdminResultsIdMapRoute,
  AppAdminResultsIdTableRoute: AppAdminResultsIdTableRoute,
  AppAdminResultsIdIndexRoute: AppAdminResultsIdIndexRoute,
}

const AppAdminResultsIdRouteWithChildren =
  AppAdminResultsIdRoute._addFileChildren(AppAdminResultsIdRouteChildren)

interface AppAdminRouteChildren {
  AppAdminGpSamplingAssignmentRoute: typeof AppAdminGpSamplingAssignmentRoute
  AppAdminNgpSamplingAssignmentRoute: typeof AppAdminNgpSamplingAssignmentRoute
  AppAdminOrdersRoute: typeof AppAdminOrdersRoute
  AppAdminOrganisationsRoute: typeof AppAdminOrganisationsRoute
  AppAdminPratiquesRoute: typeof AppAdminPratiquesRoute
  AppAdminResultsRoute: typeof AppAdminResultsRoute
  AppAdminSamplingPlansRoute: typeof AppAdminSamplingPlansRoute
  AppAdminSamplingPlansMapRoute: typeof AppAdminSamplingPlansMapRoute
  AppAdminAccountsLazyRoute: typeof AppAdminAccountsLazyRoute
  AppAdminUsersLazyRoute: typeof AppAdminUsersLazyRoute
  AppAdminOrdersIdRoute: typeof AppAdminOrdersIdRouteWithChildren
  AppAdminResultsIdRoute: typeof AppAdminResultsIdRouteWithChildren
  AppAdminSamplingPlansIdRoute: typeof AppAdminSamplingPlansIdRoute
  AppAdminAccountsCreateLazyRoute: typeof AppAdminAccountsCreateLazyRoute
  AppAdminOrganisationsCreateLazyRoute: typeof AppAdminOrganisationsCreateLazyRoute
  AppAdminUsersCreateLazyRoute: typeof AppAdminUsersCreateLazyRoute
  AppAdminAccountsAccountIdEditLazyRoute: typeof AppAdminAccountsAccountIdEditLazyRoute
  AppAdminOrganisationsOrganisationIdEditLazyRoute: typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  AppAdminUsersUserIdEditLazyRoute: typeof AppAdminUsersUserIdEditLazyRoute
}

const AppAdminRouteChildren: AppAdminRouteChildren = {
  AppAdminGpSamplingAssignmentRoute: AppAdminGpSamplingAssignmentRoute,
  AppAdminNgpSamplingAssignmentRoute: AppAdminNgpSamplingAssignmentRoute,
  AppAdminOrdersRoute: AppAdminOrdersRoute,
  AppAdminOrganisationsRoute: AppAdminOrganisationsRoute,
  AppAdminPratiquesRoute: AppAdminPratiquesRoute,
  AppAdminResultsRoute: AppAdminResultsRoute,
  AppAdminSamplingPlansRoute: AppAdminSamplingPlansRoute,
  AppAdminSamplingPlansMapRoute: AppAdminSamplingPlansMapRoute,
  AppAdminAccountsLazyRoute: AppAdminAccountsLazyRoute,
  AppAdminUsersLazyRoute: AppAdminUsersLazyRoute,
  AppAdminOrdersIdRoute: AppAdminOrdersIdRouteWithChildren,
  AppAdminResultsIdRoute: AppAdminResultsIdRouteWithChildren,
  AppAdminSamplingPlansIdRoute: AppAdminSamplingPlansIdRoute,
  AppAdminAccountsCreateLazyRoute: AppAdminAccountsCreateLazyRoute,
  AppAdminOrganisationsCreateLazyRoute: AppAdminOrganisationsCreateLazyRoute,
  AppAdminUsersCreateLazyRoute: AppAdminUsersCreateLazyRoute,
  AppAdminAccountsAccountIdEditLazyRoute:
    AppAdminAccountsAccountIdEditLazyRoute,
  AppAdminOrganisationsOrganisationIdEditLazyRoute:
    AppAdminOrganisationsOrganisationIdEditLazyRoute,
  AppAdminUsersUserIdEditLazyRoute: AppAdminUsersUserIdEditLazyRoute,
}

const AppAdminRouteWithChildren = AppAdminRoute._addFileChildren(
  AppAdminRouteChildren,
)

interface AppOsContractsContractIdRouteChildren {
  AppOsContractsContractIdBatchesRoute: typeof AppOsContractsContractIdBatchesRoute
  AppOsContractsContractIdParcellesRoute: typeof AppOsContractsContractIdParcellesRoute
  AppOsContractsContractIdIndexRoute: typeof AppOsContractsContractIdIndexRoute
  AppOsContractsContractIdBatchesBatchIdRoute: typeof AppOsContractsContractIdBatchesBatchIdRoute
}

const AppOsContractsContractIdRouteChildren: AppOsContractsContractIdRouteChildren =
  {
    AppOsContractsContractIdBatchesRoute: AppOsContractsContractIdBatchesRoute,
    AppOsContractsContractIdParcellesRoute:
      AppOsContractsContractIdParcellesRoute,
    AppOsContractsContractIdIndexRoute: AppOsContractsContractIdIndexRoute,
    AppOsContractsContractIdBatchesBatchIdRoute:
      AppOsContractsContractIdBatchesBatchIdRoute,
  }

const AppOsContractsContractIdRouteWithChildren =
  AppOsContractsContractIdRoute._addFileChildren(
    AppOsContractsContractIdRouteChildren,
  )

interface AppRouteChildren {
  AppAdminRoute: typeof AppAdminRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppImportRoute: typeof AppImportRoute
  AppSupportRoute: typeof AppSupportRoute
  AppProfileLazyRoute: typeof AppProfileLazyRoute
  AppOsContractsRoute: typeof AppOsContractsRoute
  AppOsDashboardRoute: typeof AppOsDashboardRoute
  AppOsImportRoute: typeof AppOsImportRoute
  AppOsLotReviewsRoute: typeof AppOsLotReviewsRoute
  AppOsLotsRoute: typeof AppOsLotsRoute
  AppOsNgpSamplingAssignmentRoute: typeof AppOsNgpSamplingAssignmentRoute
  AppOsSurfacesAllocationRoute: typeof AppOsSurfacesAllocationRoute
  AppOsSurfacesMapRoute: typeof AppOsSurfacesMapRoute
  AppOsValidationFormsRoute: typeof AppOsValidationFormsRoute
  AppOsContractsContractIdRoute: typeof AppOsContractsContractIdRouteWithChildren
  AppOsLotReviewsLotIdRoute: typeof AppOsLotReviewsLotIdRoute
  AppOsValidationFormsValidationFormIdRoute: typeof AppOsValidationFormsValidationFormIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRoute: AppAdminRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppImportRoute: AppImportRoute,
  AppSupportRoute: AppSupportRoute,
  AppProfileLazyRoute: AppProfileLazyRoute,
  AppOsContractsRoute: AppOsContractsRoute,
  AppOsDashboardRoute: AppOsDashboardRoute,
  AppOsImportRoute: AppOsImportRoute,
  AppOsLotReviewsRoute: AppOsLotReviewsRoute,
  AppOsLotsRoute: AppOsLotsRoute,
  AppOsNgpSamplingAssignmentRoute: AppOsNgpSamplingAssignmentRoute,
  AppOsSurfacesAllocationRoute: AppOsSurfacesAllocationRoute,
  AppOsSurfacesMapRoute: AppOsSurfacesMapRoute,
  AppOsValidationFormsRoute: AppOsValidationFormsRoute,
  AppOsContractsContractIdRoute: AppOsContractsContractIdRouteWithChildren,
  AppOsLotReviewsLotIdRoute: AppOsLotReviewsLotIdRoute,
  AppOsValidationFormsValidationFormIdRoute:
    AppOsValidationFormsValidationFormIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthLostPasswordLazyRoute: typeof AuthLostPasswordLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthLostPasswordLazyRoute: AuthLostPasswordLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AppAdminRouteWithChildren
  '/farmer-consent': typeof FarmerConsentRoute
  '/farmer-validation': typeof FarmerValidationRoute
  '/dashboard': typeof AppDashboardRoute
  '/import': typeof AppImportRoute
  '/support': typeof AppSupportRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/profile': typeof AppProfileLazyRoute
  '/lost-password': typeof AuthLostPasswordLazyRoute
  '/gp-sampling-assignment': typeof AppAdminGpSamplingAssignmentRoute
  '/ngp-sampling-assignment': typeof AppAdminNgpSamplingAssignmentRoute
  '/orders': typeof AppAdminOrdersRoute
  '/organisations': typeof AppAdminOrganisationsRoute
  '/pratiques': typeof AppAdminPratiquesRoute
  '/results': typeof AppAdminResultsRoute
  '/sampling-plans': typeof AppAdminSamplingPlansRoute
  '/sampling-plans-map': typeof AppAdminSamplingPlansMapRoute
  '/os/contracts': typeof AppOsContractsRoute
  '/os/dashboard': typeof AppOsDashboardRoute
  '/os/import': typeof AppOsImportRoute
  '/os/lot-reviews': typeof AppOsLotReviewsRoute
  '/os/lots': typeof AppOsLotsRoute
  '/os/ngp-sampling-assignment': typeof AppOsNgpSamplingAssignmentRoute
  '/os/surfaces-allocation': typeof AppOsSurfacesAllocationRoute
  '/os/surfaces-map': typeof AppOsSurfacesMapRoute
  '/os/validation-forms': typeof AppOsValidationFormsRoute
  '/accounts': typeof AppAdminAccountsLazyRoute
  '/users': typeof AppAdminUsersLazyRoute
  '/orders/$id': typeof AppAdminOrdersIdRouteWithChildren
  '/results/$id': typeof AppAdminResultsIdRouteWithChildren
  '/sampling-plans/$id': typeof AppAdminSamplingPlansIdRoute
  '/os/contracts/$contractId': typeof AppOsContractsContractIdRouteWithChildren
  '/os/lot-reviews/$lotId': typeof AppOsLotReviewsLotIdRoute
  '/os/validation-forms/$validationFormId': typeof AppOsValidationFormsValidationFormIdRoute
  '/accounts/create': typeof AppAdminAccountsCreateLazyRoute
  '/organisations/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/users/create': typeof AppAdminUsersCreateLazyRoute
  '/orders/$id/map': typeof AppAdminOrdersIdMapRoute
  '/orders/$id/points': typeof AppAdminOrdersIdPointsRoute
  '/orders/$id/track': typeof AppAdminOrdersIdTrackRoute
  '/results/$id/map': typeof AppAdminResultsIdMapRoute
  '/results/$id/table': typeof AppAdminResultsIdTableRoute
  '/os/contracts/$contractId/batches': typeof AppOsContractsContractIdBatchesRoute
  '/os/contracts/$contractId/parcelles': typeof AppOsContractsContractIdParcellesRoute
  '/accounts/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/organisations/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/users/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/results/$id/': typeof AppAdminResultsIdIndexRoute
  '/os/contracts/$contractId/': typeof AppOsContractsContractIdIndexRoute
  '/os/contracts/$contractId/batches/$batchId': typeof AppOsContractsContractIdBatchesBatchIdRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AppAdminRouteWithChildren
  '/farmer-consent': typeof FarmerConsentRoute
  '/farmer-validation': typeof FarmerValidationRoute
  '/dashboard': typeof AppDashboardRoute
  '/import': typeof AppImportRoute
  '/support': typeof AppSupportRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/profile': typeof AppProfileLazyRoute
  '/lost-password': typeof AuthLostPasswordLazyRoute
  '/gp-sampling-assignment': typeof AppAdminGpSamplingAssignmentRoute
  '/ngp-sampling-assignment': typeof AppAdminNgpSamplingAssignmentRoute
  '/orders': typeof AppAdminOrdersRoute
  '/organisations': typeof AppAdminOrganisationsRoute
  '/pratiques': typeof AppAdminPratiquesRoute
  '/results': typeof AppAdminResultsRoute
  '/sampling-plans': typeof AppAdminSamplingPlansRoute
  '/sampling-plans-map': typeof AppAdminSamplingPlansMapRoute
  '/os/contracts': typeof AppOsContractsRoute
  '/os/dashboard': typeof AppOsDashboardRoute
  '/os/import': typeof AppOsImportRoute
  '/os/lot-reviews': typeof AppOsLotReviewsRoute
  '/os/lots': typeof AppOsLotsRoute
  '/os/ngp-sampling-assignment': typeof AppOsNgpSamplingAssignmentRoute
  '/os/surfaces-allocation': typeof AppOsSurfacesAllocationRoute
  '/os/surfaces-map': typeof AppOsSurfacesMapRoute
  '/os/validation-forms': typeof AppOsValidationFormsRoute
  '/accounts': typeof AppAdminAccountsLazyRoute
  '/users': typeof AppAdminUsersLazyRoute
  '/orders/$id': typeof AppAdminOrdersIdRouteWithChildren
  '/sampling-plans/$id': typeof AppAdminSamplingPlansIdRoute
  '/os/lot-reviews/$lotId': typeof AppOsLotReviewsLotIdRoute
  '/os/validation-forms/$validationFormId': typeof AppOsValidationFormsValidationFormIdRoute
  '/accounts/create': typeof AppAdminAccountsCreateLazyRoute
  '/organisations/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/users/create': typeof AppAdminUsersCreateLazyRoute
  '/orders/$id/map': typeof AppAdminOrdersIdMapRoute
  '/orders/$id/points': typeof AppAdminOrdersIdPointsRoute
  '/orders/$id/track': typeof AppAdminOrdersIdTrackRoute
  '/results/$id/map': typeof AppAdminResultsIdMapRoute
  '/results/$id/table': typeof AppAdminResultsIdTableRoute
  '/os/contracts/$contractId/batches': typeof AppOsContractsContractIdBatchesRoute
  '/os/contracts/$contractId/parcelles': typeof AppOsContractsContractIdParcellesRoute
  '/accounts/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/organisations/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/users/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/results/$id': typeof AppAdminResultsIdIndexRoute
  '/os/contracts/$contractId': typeof AppOsContractsContractIdIndexRoute
  '/os/contracts/$contractId/batches/$batchId': typeof AppOsContractsContractIdBatchesBatchIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/farmer-consent': typeof FarmerConsentRoute
  '/farmer-validation': typeof FarmerValidationRoute
  '/_app/_admin': typeof AppAdminRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/import': typeof AppImportRoute
  '/_app/support': typeof AppSupportRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_app/profile': typeof AppProfileLazyRoute
  '/_auth/lost-password': typeof AuthLostPasswordLazyRoute
  '/_app/_admin/gp-sampling-assignment': typeof AppAdminGpSamplingAssignmentRoute
  '/_app/_admin/ngp-sampling-assignment': typeof AppAdminNgpSamplingAssignmentRoute
  '/_app/_admin/orders': typeof AppAdminOrdersRoute
  '/_app/_admin/organisations': typeof AppAdminOrganisationsRoute
  '/_app/_admin/pratiques': typeof AppAdminPratiquesRoute
  '/_app/_admin/results': typeof AppAdminResultsRoute
  '/_app/_admin/sampling-plans': typeof AppAdminSamplingPlansRoute
  '/_app/_admin/sampling-plans-map': typeof AppAdminSamplingPlansMapRoute
  '/_app/os/contracts': typeof AppOsContractsRoute
  '/_app/os/dashboard': typeof AppOsDashboardRoute
  '/_app/os/import': typeof AppOsImportRoute
  '/_app/os/lot-reviews': typeof AppOsLotReviewsRoute
  '/_app/os/lots': typeof AppOsLotsRoute
  '/_app/os/ngp-sampling-assignment': typeof AppOsNgpSamplingAssignmentRoute
  '/_app/os/surfaces-allocation': typeof AppOsSurfacesAllocationRoute
  '/_app/os/surfaces-map': typeof AppOsSurfacesMapRoute
  '/_app/os/validation-forms': typeof AppOsValidationFormsRoute
  '/_app/_admin/accounts': typeof AppAdminAccountsLazyRoute
  '/_app/_admin/users': typeof AppAdminUsersLazyRoute
  '/_app/_admin/orders_/$id': typeof AppAdminOrdersIdRouteWithChildren
  '/_app/_admin/results_/$id': typeof AppAdminResultsIdRouteWithChildren
  '/_app/_admin/sampling-plans_/$id': typeof AppAdminSamplingPlansIdRoute
  '/_app/os/contracts_/$contractId': typeof AppOsContractsContractIdRouteWithChildren
  '/_app/os/lot-reviews_/$lotId': typeof AppOsLotReviewsLotIdRoute
  '/_app/os/validation-forms_/$validationFormId': typeof AppOsValidationFormsValidationFormIdRoute
  '/_app/_admin/accounts_/create': typeof AppAdminAccountsCreateLazyRoute
  '/_app/_admin/organisations_/create': typeof AppAdminOrganisationsCreateLazyRoute
  '/_app/_admin/users_/create': typeof AppAdminUsersCreateLazyRoute
  '/_app/_admin/orders_/$id/map': typeof AppAdminOrdersIdMapRoute
  '/_app/_admin/orders_/$id/points': typeof AppAdminOrdersIdPointsRoute
  '/_app/_admin/orders_/$id/track': typeof AppAdminOrdersIdTrackRoute
  '/_app/_admin/results_/$id/map': typeof AppAdminResultsIdMapRoute
  '/_app/_admin/results_/$id/table': typeof AppAdminResultsIdTableRoute
  '/_app/os/contracts_/$contractId/batches': typeof AppOsContractsContractIdBatchesRoute
  '/_app/os/contracts_/$contractId/parcelles': typeof AppOsContractsContractIdParcellesRoute
  '/_app/_admin/accounts_/$accountId/edit': typeof AppAdminAccountsAccountIdEditLazyRoute
  '/_app/_admin/organisations_/$organisationId/edit': typeof AppAdminOrganisationsOrganisationIdEditLazyRoute
  '/_app/_admin/users_/$userId/edit': typeof AppAdminUsersUserIdEditLazyRoute
  '/_app/_admin/results_/$id/': typeof AppAdminResultsIdIndexRoute
  '/_app/os/contracts_/$contractId/': typeof AppOsContractsContractIdIndexRoute
  '/_app/os/contracts_/$contractId/batches_/$batchId': typeof AppOsContractsContractIdBatchesBatchIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/farmer-consent'
    | '/farmer-validation'
    | '/dashboard'
    | '/import'
    | '/support'
    | '/login'
    | '/reset-password'
    | '/profile'
    | '/lost-password'
    | '/gp-sampling-assignment'
    | '/ngp-sampling-assignment'
    | '/orders'
    | '/organisations'
    | '/pratiques'
    | '/results'
    | '/sampling-plans'
    | '/sampling-plans-map'
    | '/os/contracts'
    | '/os/dashboard'
    | '/os/import'
    | '/os/lot-reviews'
    | '/os/lots'
    | '/os/ngp-sampling-assignment'
    | '/os/surfaces-allocation'
    | '/os/surfaces-map'
    | '/os/validation-forms'
    | '/accounts'
    | '/users'
    | '/orders/$id'
    | '/results/$id'
    | '/sampling-plans/$id'
    | '/os/contracts/$contractId'
    | '/os/lot-reviews/$lotId'
    | '/os/validation-forms/$validationFormId'
    | '/accounts/create'
    | '/organisations/create'
    | '/users/create'
    | '/orders/$id/map'
    | '/orders/$id/points'
    | '/orders/$id/track'
    | '/results/$id/map'
    | '/results/$id/table'
    | '/os/contracts/$contractId/batches'
    | '/os/contracts/$contractId/parcelles'
    | '/accounts/$accountId/edit'
    | '/organisations/$organisationId/edit'
    | '/users/$userId/edit'
    | '/results/$id/'
    | '/os/contracts/$contractId/'
    | '/os/contracts/$contractId/batches/$batchId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/farmer-consent'
    | '/farmer-validation'
    | '/dashboard'
    | '/import'
    | '/support'
    | '/login'
    | '/reset-password'
    | '/profile'
    | '/lost-password'
    | '/gp-sampling-assignment'
    | '/ngp-sampling-assignment'
    | '/orders'
    | '/organisations'
    | '/pratiques'
    | '/results'
    | '/sampling-plans'
    | '/sampling-plans-map'
    | '/os/contracts'
    | '/os/dashboard'
    | '/os/import'
    | '/os/lot-reviews'
    | '/os/lots'
    | '/os/ngp-sampling-assignment'
    | '/os/surfaces-allocation'
    | '/os/surfaces-map'
    | '/os/validation-forms'
    | '/accounts'
    | '/users'
    | '/orders/$id'
    | '/sampling-plans/$id'
    | '/os/lot-reviews/$lotId'
    | '/os/validation-forms/$validationFormId'
    | '/accounts/create'
    | '/organisations/create'
    | '/users/create'
    | '/orders/$id/map'
    | '/orders/$id/points'
    | '/orders/$id/track'
    | '/results/$id/map'
    | '/results/$id/table'
    | '/os/contracts/$contractId/batches'
    | '/os/contracts/$contractId/parcelles'
    | '/accounts/$accountId/edit'
    | '/organisations/$organisationId/edit'
    | '/users/$userId/edit'
    | '/results/$id'
    | '/os/contracts/$contractId'
    | '/os/contracts/$contractId/batches/$batchId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/farmer-consent'
    | '/farmer-validation'
    | '/_app/_admin'
    | '/_app/dashboard'
    | '/_app/import'
    | '/_app/support'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_app/profile'
    | '/_auth/lost-password'
    | '/_app/_admin/gp-sampling-assignment'
    | '/_app/_admin/ngp-sampling-assignment'
    | '/_app/_admin/orders'
    | '/_app/_admin/organisations'
    | '/_app/_admin/pratiques'
    | '/_app/_admin/results'
    | '/_app/_admin/sampling-plans'
    | '/_app/_admin/sampling-plans-map'
    | '/_app/os/contracts'
    | '/_app/os/dashboard'
    | '/_app/os/import'
    | '/_app/os/lot-reviews'
    | '/_app/os/lots'
    | '/_app/os/ngp-sampling-assignment'
    | '/_app/os/surfaces-allocation'
    | '/_app/os/surfaces-map'
    | '/_app/os/validation-forms'
    | '/_app/_admin/accounts'
    | '/_app/_admin/users'
    | '/_app/_admin/orders_/$id'
    | '/_app/_admin/results_/$id'
    | '/_app/_admin/sampling-plans_/$id'
    | '/_app/os/contracts_/$contractId'
    | '/_app/os/lot-reviews_/$lotId'
    | '/_app/os/validation-forms_/$validationFormId'
    | '/_app/_admin/accounts_/create'
    | '/_app/_admin/organisations_/create'
    | '/_app/_admin/users_/create'
    | '/_app/_admin/orders_/$id/map'
    | '/_app/_admin/orders_/$id/points'
    | '/_app/_admin/orders_/$id/track'
    | '/_app/_admin/results_/$id/map'
    | '/_app/_admin/results_/$id/table'
    | '/_app/os/contracts_/$contractId/batches'
    | '/_app/os/contracts_/$contractId/parcelles'
    | '/_app/_admin/accounts_/$accountId/edit'
    | '/_app/_admin/organisations_/$organisationId/edit'
    | '/_app/_admin/users_/$userId/edit'
    | '/_app/_admin/results_/$id/'
    | '/_app/os/contracts_/$contractId/'
    | '/_app/os/contracts_/$contractId/batches_/$batchId'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  FarmerConsentRoute: typeof FarmerConsentRoute
  FarmerValidationRoute: typeof FarmerValidationRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  FarmerConsentRoute: FarmerConsentRoute,
  FarmerValidationRoute: FarmerValidationRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_app",
        "/_auth",
        "/farmer-consent",
        "/farmer-validation"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/_admin",
        "/_app/dashboard",
        "/_app/import",
        "/_app/support",
        "/_app/profile",
        "/_app/os/contracts",
        "/_app/os/dashboard",
        "/_app/os/import",
        "/_app/os/lot-reviews",
        "/_app/os/lots",
        "/_app/os/ngp-sampling-assignment",
        "/_app/os/surfaces-allocation",
        "/_app/os/surfaces-map",
        "/_app/os/validation-forms",
        "/_app/os/contracts_/$contractId",
        "/_app/os/lot-reviews_/$lotId",
        "/_app/os/validation-forms_/$validationFormId"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/login",
        "/_auth/reset-password",
        "/_auth/lost-password"
      ]
    },
    "/farmer-consent": {
      "filePath": "farmer-consent.tsx"
    },
    "/farmer-validation": {
      "filePath": "farmer-validation.tsx"
    },
    "/_app/_admin": {
      "filePath": "_app/_admin.tsx",
      "parent": "/_app",
      "children": [
        "/_app/_admin/gp-sampling-assignment",
        "/_app/_admin/ngp-sampling-assignment",
        "/_app/_admin/orders",
        "/_app/_admin/organisations",
        "/_app/_admin/pratiques",
        "/_app/_admin/results",
        "/_app/_admin/sampling-plans",
        "/_app/_admin/sampling-plans-map",
        "/_app/_admin/accounts",
        "/_app/_admin/users",
        "/_app/_admin/orders_/$id",
        "/_app/_admin/results_/$id",
        "/_app/_admin/sampling-plans_/$id",
        "/_app/_admin/accounts_/create",
        "/_app/_admin/organisations_/create",
        "/_app/_admin/users_/create",
        "/_app/_admin/accounts_/$accountId/edit",
        "/_app/_admin/organisations_/$organisationId/edit",
        "/_app/_admin/users_/$userId/edit"
      ]
    },
    "/_app/dashboard": {
      "filePath": "_app/dashboard.tsx",
      "parent": "/_app"
    },
    "/_app/import": {
      "filePath": "_app/import.tsx",
      "parent": "/_app"
    },
    "/_app/support": {
      "filePath": "_app/support.tsx",
      "parent": "/_app"
    },
    "/_auth/login": {
      "filePath": "_auth/login.tsx",
      "parent": "/_auth"
    },
    "/_auth/reset-password": {
      "filePath": "_auth/reset-password.tsx",
      "parent": "/_auth"
    },
    "/_app/profile": {
      "filePath": "_app/profile.lazy.tsx",
      "parent": "/_app"
    },
    "/_auth/lost-password": {
      "filePath": "_auth/lost-password.lazy.tsx",
      "parent": "/_auth"
    },
    "/_app/_admin/gp-sampling-assignment": {
      "filePath": "_app/_admin/gp-sampling-assignment.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/ngp-sampling-assignment": {
      "filePath": "_app/_admin/ngp-sampling-assignment.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/orders": {
      "filePath": "_app/_admin/orders.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/organisations": {
      "filePath": "_app/_admin/organisations.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/pratiques": {
      "filePath": "_app/_admin/pratiques.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/results": {
      "filePath": "_app/_admin/results.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/sampling-plans": {
      "filePath": "_app/_admin/sampling-plans.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/sampling-plans-map": {
      "filePath": "_app/_admin/sampling-plans-map.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/os/contracts": {
      "filePath": "_app/os/contracts.tsx",
      "parent": "/_app"
    },
    "/_app/os/dashboard": {
      "filePath": "_app/os/dashboard.tsx",
      "parent": "/_app"
    },
    "/_app/os/import": {
      "filePath": "_app/os/import.tsx",
      "parent": "/_app"
    },
    "/_app/os/lot-reviews": {
      "filePath": "_app/os/lot-reviews.tsx",
      "parent": "/_app"
    },
    "/_app/os/lots": {
      "filePath": "_app/os/lots.tsx",
      "parent": "/_app"
    },
    "/_app/os/ngp-sampling-assignment": {
      "filePath": "_app/os/ngp-sampling-assignment.tsx",
      "parent": "/_app"
    },
    "/_app/os/surfaces-allocation": {
      "filePath": "_app/os/surfaces-allocation.tsx",
      "parent": "/_app"
    },
    "/_app/os/surfaces-map": {
      "filePath": "_app/os/surfaces-map.tsx",
      "parent": "/_app"
    },
    "/_app/os/validation-forms": {
      "filePath": "_app/os/validation-forms.tsx",
      "parent": "/_app"
    },
    "/_app/_admin/accounts": {
      "filePath": "_app/_admin/accounts.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users": {
      "filePath": "_app/_admin/users.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/orders_/$id": {
      "filePath": "_app/_admin/orders_/$id.tsx",
      "parent": "/_app/_admin",
      "children": [
        "/_app/_admin/orders_/$id/map",
        "/_app/_admin/orders_/$id/points",
        "/_app/_admin/orders_/$id/track"
      ]
    },
    "/_app/_admin/results_/$id": {
      "filePath": "_app/_admin/results_/$id.tsx",
      "parent": "/_app/_admin",
      "children": [
        "/_app/_admin/results_/$id/map",
        "/_app/_admin/results_/$id/table",
        "/_app/_admin/results_/$id/"
      ]
    },
    "/_app/_admin/sampling-plans_/$id": {
      "filePath": "_app/_admin/sampling-plans_.$id.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/os/contracts_/$contractId": {
      "filePath": "_app/os/contracts_.$contractId.tsx",
      "parent": "/_app",
      "children": [
        "/_app/os/contracts_/$contractId/batches",
        "/_app/os/contracts_/$contractId/parcelles",
        "/_app/os/contracts_/$contractId/",
        "/_app/os/contracts_/$contractId/batches_/$batchId"
      ]
    },
    "/_app/os/lot-reviews_/$lotId": {
      "filePath": "_app/os/lot-reviews_.$lotId.tsx",
      "parent": "/_app"
    },
    "/_app/os/validation-forms_/$validationFormId": {
      "filePath": "_app/os/validation-forms_.$validationFormId.tsx",
      "parent": "/_app"
    },
    "/_app/_admin/accounts_/create": {
      "filePath": "_app/_admin/accounts_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/organisations_/create": {
      "filePath": "_app/_admin/organisations_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users_/create": {
      "filePath": "_app/_admin/users_/create.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/orders_/$id/map": {
      "filePath": "_app/_admin/orders_/$id.map.tsx",
      "parent": "/_app/_admin/orders_/$id"
    },
    "/_app/_admin/orders_/$id/points": {
      "filePath": "_app/_admin/orders_/$id.points.tsx",
      "parent": "/_app/_admin/orders_/$id"
    },
    "/_app/_admin/orders_/$id/track": {
      "filePath": "_app/_admin/orders_/$id.track.tsx",
      "parent": "/_app/_admin/orders_/$id"
    },
    "/_app/_admin/results_/$id/map": {
      "filePath": "_app/_admin/results_/$id.map.tsx",
      "parent": "/_app/_admin/results_/$id"
    },
    "/_app/_admin/results_/$id/table": {
      "filePath": "_app/_admin/results_/$id.table.tsx",
      "parent": "/_app/_admin/results_/$id"
    },
    "/_app/os/contracts_/$contractId/batches": {
      "filePath": "_app/os/contracts_.$contractId.batches.tsx",
      "parent": "/_app/os/contracts_/$contractId"
    },
    "/_app/os/contracts_/$contractId/parcelles": {
      "filePath": "_app/os/contracts_.$contractId.parcelles.tsx",
      "parent": "/_app/os/contracts_/$contractId"
    },
    "/_app/_admin/accounts_/$accountId/edit": {
      "filePath": "_app/_admin/accounts_/$accountId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/organisations_/$organisationId/edit": {
      "filePath": "_app/_admin/organisations_/$organisationId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/users_/$userId/edit": {
      "filePath": "_app/_admin/users_/$userId.edit.lazy.tsx",
      "parent": "/_app/_admin"
    },
    "/_app/_admin/results_/$id/": {
      "filePath": "_app/_admin/results_/$id.index.tsx",
      "parent": "/_app/_admin/results_/$id"
    },
    "/_app/os/contracts_/$contractId/": {
      "filePath": "_app/os/contracts_.$contractId.index.tsx",
      "parent": "/_app/os/contracts_/$contractId"
    },
    "/_app/os/contracts_/$contractId/batches_/$batchId": {
      "filePath": "_app/os/contracts_.$contractId.batches_.$batchId.tsx",
      "parent": "/_app/os/contracts_/$contractId"
    }
  }
}
ROUTE_MANIFEST_END */
